/* VELYRA — interacciones propias (prefijo vl-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.vl-reveal:not(.vl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vl-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-vl-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-vl-count')) || 0;
      if (reduce) { el.textContent = target; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function formatMoney(cents, fmt) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initProducts(root) {
    (root || document).querySelectorAll('[data-vl-product]').forEach(function (wrap) {
      if (wrap.dataset.vlReady) return;
      wrap.dataset.vlReady = '1';
      var dataEl = wrap.querySelector('[data-vl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = wrap.getAttribute('data-money-format');
      var idInput = wrap.querySelector('input[name="id"]');
      var btn = wrap.querySelector('[data-vl-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var addText = btn ? btn.getAttribute('data-add') : '';
      var soldText = btn ? btn.getAttribute('data-sold') : '';
      var priceNow = wrap.querySelectorAll('[data-vl-price]');
      var priceOld = wrap.querySelector('[data-vl-compare]');
      var save = wrap.querySelector('[data-vl-save]');
      var main = wrap.querySelector('[data-vl-main]');
      var thumbs = wrap.querySelectorAll('[data-vl-thumb]');

      function showMedia(src, id) {
        if (!main || !src) return;
        main.style.opacity = '0';
        setTimeout(function () { main.src = src; main.removeAttribute('srcset'); main.style.opacity = '1'; }, 150);
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') == id ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var mid = t.getAttribute('data-media-id');
          showMedia(t.getAttribute('data-src'), mid);
          // Si la foto pertenece a un color (variante), selecciona ese color automáticamente
          var match = variants.find(function (v) { return v.featured_media && String(v.featured_media.id) === String(mid); });
          if (!match) return;
          var sets = wrap.querySelectorAll('[data-vl-option]');
          var changed = false;
          sets.forEach(function (fs, i) {
            fs.querySelectorAll('input').forEach(function (inp) {
              if (inp.value === match.options[i] && !inp.checked) { inp.checked = true; changed = true; }
            });
          });
          if (changed) update();
        });
      });

      function current() {
        var chosen = [];
        wrap.querySelectorAll('[data-vl-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-vl-option-label]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return chosen[i] === null || o === chosen[i]; });
        });
      }
      function update() {
        var v = current();
        if (!v) {
          if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = soldText; }
          return;
        }
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = formatMoney(v.price, fmt); });
        if (priceOld) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          priceOld.textContent = onSale ? formatMoney(v.compare_at_price, fmt) : '';
          priceOld.hidden = !onSale;
          if (save) {
            save.hidden = !onSale;
            if (onSale) save.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        if (btn) {
          btn.disabled = !v.available;
          if (btnLabel) btnLabel.textContent = v.available ? addText : soldText;
        }
        // solo las miniaturas del color elegido
        var vc = String(v.option1 || '').toLowerCase();
        thumbs.forEach(function (th) {
          var c = th.getAttribute('data-color');
          th.hidden = !!c && vc.indexOf(c) === -1;
        });
        if (v.featured_media && v.featured_media.id) {
          var t = wrap.querySelector('[data-vl-thumb][data-media-id="' + v.featured_media.id + '"]');
          if (t) showMedia(t.getAttribute('data-src'), v.featured_media.id);
        }
        if (window.history && window.history.replaceState && wrap.hasAttribute('data-vl-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      wrap.querySelectorAll('[data-vl-option] input').forEach(function (i) { i.addEventListener('change', update); });

      var packBtn = wrap.querySelector('[data-vl-pack]');
      if (packBtn) {
        var packLabel = packBtn.textContent;
        packBtn.addEventListener('click', function () {
          var q = wrap.querySelector('[data-vl-qty] input');
          if (!q) return;
          // Segundo clic: deshace el pack y vuelve a 1 unidad
          if (packBtn.classList.contains('is-on')) {
            q.value = '1';
            packBtn.classList.remove('is-on');
            packBtn.textContent = packLabel;
          } else {
            q.value = packBtn.getAttribute('data-vl-pack') || '2';
            packBtn.classList.add('is-on');
            packBtn.textContent = '✓ ' + q.value + ' elegidos';
          }
          var qb = wrap.querySelector('[data-vl-qty]');
          if (qb) { qb.classList.remove('vl-flash'); void qb.offsetWidth; qb.classList.add('vl-flash'); }
        });
        // Si cambian la cantidad a mano (+ / −), el botón se desmarca
        var qbox = wrap.querySelector('[data-vl-qty]');
        if (qbox) {
          var syncPack = function () {
            var q = qbox.querySelector('input');
            if (packBtn.classList.contains('is-on') && q && q.value !== (packBtn.getAttribute('data-vl-pack') || '2')) {
              packBtn.classList.remove('is-on');
              packBtn.textContent = packLabel;
            }
          };
          qbox.addEventListener('click', function () { setTimeout(syncPack, 0); });
          qbox.addEventListener('input', syncPack);
        }
      }

      var qty = wrap.querySelector('[data-vl-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n = b.getAttribute('data-step') === '+' ? n + 1 : Math.max(1, n - 1);
            input.value = n;
          });
        });
      }

      /* Añadir al carrito: usa el cajón/aviso de carrito de Dawn si existe; si no, envío normal */
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var msg = wrap.querySelector('[data-vl-msg]');
      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function') return;
          ev.preventDefault();
          if (btn) btn.setAttribute('aria-busy', 'true');
          if (msg) msg.textContent = '';
          var fd = new FormData(form);
          if (cart.getSectionsToRender) {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (msg) msg.textContent = res.description || res.message || 'No se pudo añadir.';
                return;
              }
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              var inner = cart.querySelector('.drawer__inner');
              if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
        });
      }

      /* Barra de compra fija en móvil */
      var bar = document.querySelector('[data-vl-sticky-buy]');
      if (bar && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var past = !e.isIntersecting && e.boundingClientRect.top < 0;
            bar.classList.toggle('is-on', past);
          });
        });
        io.observe(btn);
        var barBtn = bar.querySelector('button');
        if (barBtn) barBtn.addEventListener('click', function () { btn.click(); });
      }
    });
  }

  /* Manifiesto: las palabras se iluminan según avanza el scroll */
  function initWords(root) {
    var blocks = (root || document).querySelectorAll('[data-vl-words]');
    if (!blocks.length) return;
    if (reduce) { blocks.forEach(function (b) { b.querySelectorAll('.vl-w').forEach(function (w) { w.classList.add('is-on'); }); }); return; }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      blocks.forEach(function (b) {
        var r = b.getBoundingClientRect();
        var start = vh * 0.85, end = vh * 0.35;
        var p = (start - r.top) / (start - end + r.height * 0.6);
        p = Math.max(0, Math.min(1, p));
        var words = b.querySelectorAll('.vl-w');
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Inclinación suave del producto con el ratón */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-vl-tilt]').forEach(function (img) {
      var box = img.closest('.vl-hero__visual') || img.parentElement;
      var wrap = img.parentElement;
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        wrap.style.transform = 'perspective(1200px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 8) + 'deg)';
      });
      box.addEventListener('mouseleave', function () { wrap.style.transform = ''; });
      wrap.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
    });
  }

  /* Panel de detalles: al pasar por cada uno se ilumina esa parte del vaso */
  function initLights(root) {
    (root || document).querySelectorAll('[data-vl-lights]').forEach(function (box) {
      if (box.dataset.vlLightsReady) return;
      box.dataset.vlLightsReady = '1';
      var items = Array.prototype.slice.call(box.querySelectorAll('[data-vl-part]'));
      if (!items.length) return;
      var lights = box.querySelectorAll('[data-vl-light]');
      function show(part) {
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-vl-part') === part); });
        lights.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-vl-light') === part); });
      }
      var auto = box.hasAttribute('data-vl-auto') && !reduce, idx = -1, timer = null, paused = false;
      function next() {
        if (paused) return;
        idx = (idx + 1) % items.length;
        show(items[idx].getAttribute('data-vl-part'));
      }
      function start() { if (auto && !timer) { timer = setInterval(next, 2600); } }
      function stop() { clearInterval(timer); timer = null; }
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { paused = true; stop(); idx = i; show(it.getAttribute('data-vl-part')); });
        it.addEventListener('focus', function () { paused = true; stop(); idx = i; show(it.getAttribute('data-vl-part')); });
        it.addEventListener('click', function () { paused = true; stop(); idx = i; show(it.getAttribute('data-vl-part')); });
      });
      var rail = box.querySelector('.vl-rail');
      if (rail) rail.addEventListener('mouseleave', function () { paused = false; if (auto) { start(); } else { show(null); } });
      if (auto) { setTimeout(function () { next(); start(); }, 1400); }
    });
  }

  /* Botón de correo: en móviles abre la app de correo en lugar de una pestaña */
  function initMail(root) {
    if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    (root || document).querySelectorAll('[data-vl-mailto]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('data-vl-mailto'));
      a.removeAttribute('target');
    });
  }

  /* Formulario de contacto en ventana (dialog) */
  function initContact(root) {
    (root || document).querySelectorAll('[data-vl-open-contact]').forEach(function (btn) {
      var dlg = document.getElementById(btn.getAttribute('data-vl-open-contact'));
      if (!dlg || dlg.dataset.vlReady) return;
      dlg.dataset.vlReady = '1';
      function open() {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('vl-modal-open');
        var first = dlg.querySelector('input:not([type=hidden]), textarea, button[data-vl-close]');
        if (first) setTimeout(function () { first.focus(); }, 50);
      }
      function close() {
        if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
        document.documentElement.classList.remove('vl-modal-open');
      }
      btn.addEventListener('click', open);
      dlg.querySelectorAll('[data-vl-close]').forEach(function (c) { c.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('vl-modal-open'); });
      var form = dlg.querySelector('form');
      if (form) form.addEventListener('submit', function () {
        var send = form.querySelector('.vl-modal__send');
        if (send) { send.setAttribute('aria-busy', 'true'); send.querySelector('span').textContent = 'Enviando…'; }
      });
      // Tras enviar, la página se recarga: reabrimos para mostrar el resultado
      if (dlg.querySelector('[data-vl-autoopen]')) open();
    });
  }

  /* Código de bienvenida: se aplica solo a quien se ha suscrito (carrito + pago) */
  var CODE_KEY = 'vl-codigo-bienvenida';
  function applyDiscount(code) {
    if (!code || !window.fetch) return;
    // 1) enlace de descuento de Shopify: deja el código guardado para la pantalla de pago
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        // 2) lo aplica también al carrito para que el cliente vea el descuento antes de pagar
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        });
      })
      .catch(function () {});
  }
  function reapplyDiscount() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(CODE_KEY) || 'null'); } catch (e) {}
    if (!saved || !saved.code) return;
    if (saved.until && saved.until < Date.now()) { try { localStorage.removeItem(CODE_KEY); } catch (e) {} return; }
    var flag = 'vl-codigo-aplicado';
    try { if (sessionStorage.getItem(flag)) return; sessionStorage.setItem(flag, '1'); } catch (e) {}
    applyDiscount(saved.code);
  }

  /* Ventana de bienvenida (descuento primera compra) */
  function initPopup() {
    var dlg = document.querySelector('[data-vl-popup]');
    if (!dlg || dlg.dataset.vlReady) return;
    dlg.dataset.vlReady = '1';
    var KEY = 'vl-popup-hasta';
    var days = parseFloat(dlg.getAttribute('data-days')) || 14;
    var delay = (parseFloat(dlg.getAttribute('data-delay')) || 10) * 1000;
    function remember(d) { try { localStorage.setItem(KEY, String(Date.now() + d * 86400000)); } catch (e) {} }
    function open() {
      if (document.querySelector('dialog[open]')) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('vl-modal-open');
    }
    function close() {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      document.documentElement.classList.remove('vl-modal-open');
      remember(days);
    }
    dlg.querySelectorAll('[data-vl-close]').forEach(function (c) { c.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', function () { remember(days); });
    var copy = dlg.querySelector('[data-vl-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = dlg.querySelector('[data-vl-code]').textContent.trim();
      var done = function () { copy.textContent = '¡Copiado!'; setTimeout(function () { copy.textContent = 'Copiar'; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
    // Tras suscribirse (o si hubo un error) la página se recarga: se abre directamente
    if (dlg.querySelector('[data-vl-autoopen]')) {
      var applyEl = dlg.querySelector('[data-vl-apply-code]');
      if (applyEl) {
        var code = applyEl.getAttribute('data-vl-apply-code');
        try { localStorage.setItem(CODE_KEY, JSON.stringify({ code: code, until: Date.now() + 30 * 86400000 })); } catch (e) {}
        applyDiscount(code);
      }
      remember(365); open(); return;
    }
    // Para probarla: añadir ?bienvenida a la dirección la muestra siempre
    if (/[?&]bienvenida\b/.test(location.search)) { setTimeout(open, 600); return; }
    var until = 0;
    try { until = parseFloat(localStorage.getItem(KEY)) || 0; } catch (e) {}
    if (until > Date.now()) return;
    setTimeout(open, delay);
  }

  /* Rastrear pedido: abre la web de seguimiento con el número escrito */
  function initTrack(root) {
    (root || document).querySelectorAll('[data-vl-track]').forEach(function (f) {
      if (f.dataset.vlReady) return;
      f.dataset.vlReady = '1';
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = (f.querySelector('input[name=n]').value || '').replace(/\s+/g, '').trim();
        if (!n) return;
        var url = (f.getAttribute('data-url') || 'https://t.17track.net/es#nums={n}').replace('{n}', encodeURIComponent(n));
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  function initAll(root) {
    if (!root) reapplyDiscount();
    initTrack(root);
    initPopup();
    initContact(root);
    initMail(root);
    initLights(root);
    initReveals(root);
    initCounters(root);
    initProducts(root);
    initWords(root);
    initTilt(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
